import _ from 'underscore';

export const markTime = () => ({
  time: performance.now(),
  activeTime: _.result(performance, 'activeTime', NaN),
});

export const startActivity = (activity) => {
  const { time, activeTime } = markTime();
  // eslint-disable-next-line no-param-reassign
  activity.properties = {
    startTime: time,
    activeStartTime: activeTime,
  };
  activity.trace(`startTime: ${time}, activeStartTime: ${activeTime}`);
};

export const endActivity = (activity) => {
  const { time, activeTime } = markTime();
  const { activeStartTime, startTime } = activity.properties || {};
  const activeDuration = activeStartTime ? activeTime - activeStartTime : 0;
  const duration = startTime ? time - startTime : 0;
  activity.trace(`endTime: ${time}, activeEndTime: ${activeTime}, activeDuration: ${activeDuration}, duration: ${duration}`);
};
